import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { Colors } from "../../constants/colors";
/**
 * AIPrimaryButton - A primary action button styled based on XAML AIPrimaryButtonStyle
 *
 * Style Properties:
 * - Foreground: White
 * - Background: PrimaryPurple70 (from colors.ts)
 * - BorderBrush: Transparent
 * - FontSize: 13px
 * - FontWeight: 700 (Bold)
 * - BorderRadius: 8px
 * - Width: 36px
 * - Height: 36px
 * - Padding: 9.5px 16px (default)
 * - Gap: 8px
 * - Hover: Background changes to PrimaryPurple60 (from colors.ts)
 * - Pressed: Background changes to PrimaryPurple80 (from colors.ts)
 * - Disabled: Background Gray300, Foreground Gray600 (from colors.ts)
 */
export const AIPrimaryButton = ({ icon, children, onClick, disabled = false, className = "", width = "36px", height = "36px", padding = "9.5px 16px", }) => {
    const [isPressed, setIsPressed] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    // Determine background color based on state
    const getBackgroundColor = () => {
        if (disabled) {
            return Colors.Gray300;
        }
        if (isPressed) {
            return Colors.PrimaryPurple80;
        }
        if (isHovered) {
            return Colors.PrimaryPurple60;
        }
        return Colors.PrimaryPurple70;
    };
    // Determine foreground color based on state
    const getForegroundColor = () => {
        if (disabled) {
            return Colors.Gray600;
        }
        return "white"; // White
    };
    return (
    // eslint-disable-next-line
    _jsx("button", { onClick: onClick, disabled: disabled, onMouseDown: () => setIsPressed(true), onMouseUp: () => setIsPressed(false), onMouseLeave: () => {
            setIsPressed(false);
            setIsHovered(false);
        }, onMouseEnter: () => setIsHovered(true), className: `flex flex-col items-center justify-center transition-colors ${className}`, style: {
            width: width,
            height: height,
            padding: padding,
            gap: "8px",
            backgroundColor: getBackgroundColor(),
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "transparent",
            borderRadius: "8px",
            color: getForegroundColor(),
            fontSize: "13px",
            fontStyle: "normal",
            fontWeight: 700,
            cursor: disabled ? "not-allowed" : "pointer",
        }, children: icon || children }));
};
export default AIPrimaryButton;
